import { FC } from "react";
import { Outlet } from "react-router-dom";

const TrainingSection: FC = () => {
  return <Outlet />;
};
export default TrainingSection;
